/* eslint-disable */
import React, { useState } from 'react';
import { Dialog, DialogActions, DialogTitle, Slide, TextField, Box, Button, Link, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { handleCatchError } from 'utils/CatchHandler';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import { handleCapture } from 'views/utilities/BiometricCapture';
import ViewCustomerAuth from './BioAuthAnimation';
import Spinner from 'views/Components/LoadingSinner';
import { useProcessEkyc, useResendOtp, useVerifyOtp } from '../DmtHooks';
import { LoadingButton } from '@mui/lab';

const commonStyles = { m: 0 };
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function BioAuthExistingUsers({ showModal, datas, filteredData, index }) {
    const navigate = useNavigate();
    const ekycMutation = useProcessEkyc();
    const resendOtpMutation = useResendOtp();
    const verifyOtpMutation = useVerifyOtp();

    const [showOtpField, setShowOtpField] = useState(false);
    const [showFingerGif, setShowFingerGif] = useState(false);
    const [otpId, setOtpId] = useState('');
    const [kycId, setKycId] = useState('');

    const isLoading = ekycMutation.isPending || resendOtpMutation.isPending || verifyOtpMutation.isPending;

    const handleClose = () => {
        showModal(false);
    };

    const initialValues = {
        aadhar: '',
        otp: ''
    };

    const validationSchema = Yup.object().shape({
        aadhar: Yup.string().when([], {
            is: () => !showOtpField,
            then: (schema) => schema.required('Aadhaar is required').matches(/^\d{12}$/, 'Please enter a valid 12 digit Aadhaar number'),
            otherwise: (schema) => schema
        }),
        otp: Yup.string().when([], {
            is: () => showOtpField,
            then: (schema) => schema.required('OTP is required').length(4, 'OTP must be 4 digits'),
            otherwise: (schema) => schema
        })
    });

    const handleResendOtp = (values) => {
        const payload = {
            CustomerName: datas?.name,
            CustomerMobileNo: datas?.customermob,
            agentId: '2',
            aadharNo: values.aadhar,
            dmt_type: 1
        };
        resendOtpMutation.mutate(payload, {
            onSuccess: (response) => {
                if (response?.data?.success) {
                    globalNotifySuccess(response?.data?.message);
                    setOtpId(response?.data?.data?.otpRequestId);
                } else if (response?.data?.ResponseCode === 101) {
                    handleClose();
                }
            },
            onError: (error) => {
                handleCatchError(error);
            }
        });
    };

    const submitHandler = (values, { setSubmitting }) => {
        if (!showOtpField) {
            setShowFingerGif(true);
            setTimeout(() => {
                handleCapture((data) => {
                    setShowFingerGif(false);
                    if (data) {
                        const payload = {
                            CustomerName: datas?.customerName,
                            CustomerMobileNo: datas?.mobileNumber,
                            agentId: '2',
                            AadharNo: values.aadhar,
                            Pid: data,
                            dmtType: 1
                        };
                        ekycMutation.mutate(payload, {
                            onSuccess: (response) => {
                                if (response?.data?.success) {
                                    globalNotifySuccess(response?.data?.message);
                                    setShowOtpField(true);
                                    setOtpId(response?.data?.data?.OTPRequestID);
                                    setKycId(response?.data?.data?.KYCRequestID);
                                } else if (response?.data?.ResponseCode === 2) {
                                    globalNotifyError('Please resent the otp');
                                    setKycId(response?.data?.KYCRequestID);
                                } else {
                                    globalNotifyError(response?.data?.data?.message);
                                }
                            },
                            onError: (error) => {
                                handleCatchError(error);
                            },
                            onSettled: () => setSubmitting(false)
                        });
                    } else {
                        setSubmitting(false);
                    }
                });
            }, 1000);
        } else {
            const payload = {
                CustomerName: datas?.customerName,
                CustomerMobileNo: datas?.mobileNumber,
                agentId: '2',
                OTPPin: values.otp,
                otpRequestId: otpId,
                kycRequestId: kycId,
                dmtType: 1
            };
            verifyOtpMutation.mutate(payload, {
                onSuccess: (response) => {
                    if (response?.data?.success) {
                        globalNotifySuccess(response?.data?.message);
                        navigate('/moneyTransfer1/viewCustomers', { state: { item: datas, filteredData, index } });
                    }
                },
                onError: (error) => handleCatchError(error),
                onSettled: () => setSubmitting(false)
            });
        }
    };

    return (
        <>
            <Dialog
                open={true}
                TransitionComponent={Transition}
                onClose={handleClose}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    '& .MuiDialog-paper': {
                        width: '100%',
                        maxWidth: '600px',
                        margin: '0 auto',
                        padding: { xs: '10px', sm: '20px' },
                        '@media (max-width: 600px)': {
                            width: '90%'
                        }
                    }
                }}
            >
                <DialogTitle>{'Verify Your EKYC'}</DialogTitle>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={submitHandler}>
                    {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, isValid }) => (
                        <Form>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    backgroundColor: '#fff',
                                    ...commonStyles,
                                    borderRadius: 2,
                                    marginBottom: 2,
                                    padding: { xs: '10px', sm: '20px' }
                                }}
                            >
                                {!showOtpField ? (
                                    <>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    id="outlined-basic"
                                                    label="Aadhaar Number"
                                                    name="aadhar"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={values.aadhar}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/[^\d]/g, '').slice(0, 12);
                                                        handleChange({ target: { name: 'aadhar', value: val } });
                                                    }}
                                                    helperText={touched.aadhar && errors.aadhar}
                                                    error={touched.aadhar && Boolean(errors.aadhar)}
                                                    onBlur={handleBlur}
                                                />
                                            </Grid>
                                        </Grid>
                                        <DialogActions>
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                disabled={isLoading || !values.aadhar || isSubmitting || !isValid}
                                                onClick={handleSubmit}
                                            >
                                                Submit
                                            </Button>
                                        </DialogActions>
                                    </>
                                ) : (
                                    <>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    id="outlined-basic"
                                                    label="OTP Number"
                                                    name="otp"
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    value={values.otp}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/[^\d]/g, '').slice(0, 4);
                                                        handleChange({ target: { name: 'otp', value: val } });
                                                    }}
                                                    helperText={touched.otp && errors.otp}
                                                    error={touched.otp && Boolean(errors.otp)}
                                                    onBlur={handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} container justifyContent="flex-end">
                                                <Link
                                                    component="button"
                                                    variant="body2"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleResendOtp(values);
                                                    }}
                                                    disabled={isLoading}
                                                >
                                                    Resend OTP
                                                </Link>
                                            </Grid>
                                        </Grid>
                                        <LoadingButton
                                            variant="contained"
                                            sx={{ mt: 1 }}
                                            fullWidth
                                            disabled={isLoading || !values.otp || isSubmitting}
                                            onClick={handleSubmit}
                                        >
                                            Verify
                                        </LoadingButton>
                                    </>
                                )}
                            </Box>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Spinner loading={isLoading} />
            {showFingerGif && <ViewCustomerAuth />}
        </>
    );
}

export default BioAuthExistingUsers;
